// Full-screen fallback rendered by the root Sentry ErrorBoundary when the
// React tree crashes. It may mount outside every provider (i18next React
// context included), so it translates via the module-level i18n instance
// (initialized in main.tsx before App) instead of the useTranslation hook.

import { TriangleAlert } from 'lucide-react';
import i18n from '@/i18n/config';

export function AppErrorFallback() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div
        role="alert"
        className="w-full max-w-sm rounded-lg border border-border bg-card p-6 text-center"
      >
        <TriangleAlert
          className="mx-auto mb-4 size-8 text-muted-foreground"
          aria-hidden="true"
        />
        <h1 className="text-lg font-semibold text-foreground">
          {i18n.t('errorFallback.title', { ns: 'common' })}
        </h1>
        <p className="mt-2 text-sm text-muted-foreground">
          {i18n.t('errorFallback.message', { ns: 'common' })}
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="mt-6 inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
        >
          {i18n.t('errorFallback.reload', { ns: 'common' })}
        </button>
      </div>
    </div>
  );
}
